<script lang="ts">
  // components
  import Icon from "@shared/svelte/Components/Icon.svelte";

  // stores
  import layoutStore from "@shared/svelte/Stores/LayoutStore";

  export let extraClassNames = "";

</script>

<div class={"fizz-flex-row-8 " + extraClassNames}>
  <div style="position:relative; top: -1px">
    <Icon id="provi-pay-icon" type="ProviPay" height="14" width="85" />
  </div>
  <p class="fizz-text-medium fizz-text-subdued">Manage and pay distributor invoices</p>
</div>
